const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!content) { el?.remove(); return; }
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!href) { el?.remove(); return; }
  if (!el) { el = document.createElement("link"); el.rel = "canonical"; document.head.appendChild(el); }
  el.href = href;
};

export const applySeo = (seo = {}) => {
  if (seo.title) document.title = seo.title;
  setMeta("name", "description", seo.description);
  const st = seo.social_title || seo.title;
  const sd = seo.social_description || seo.description;
  setMeta("property", "og:title", st);
  setMeta("property", "og:description", sd);
  setMeta("name", "twitter:title", st);
  setMeta("name", "twitter:description", sd);
  setMeta("name", "robots", seo.indexable === false ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1");
  const url = seo.site_url ? `${seo.site_url}/` : "";
  setCanonical(url);
  setMeta("property", "og:url", url);
};

export const noIndex = () => setMeta("name", "robots", "noindex, nofollow");
